import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { isMobile } from 'react-device-detect';
// import RoomBuilding from './RoomBuilding';
import VideoPlayer from '../common/VideoPlayer';

const Photogrammetry = () => {
    const responsive = {
        desktop: {
          breakpoint: { max: 5000, min: 1024 },
          items: 1,
        //   slidesToSlide: 3 // optional, default to 1.
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1,
        //   slidesToSlide: 2 // optional, default to 1.
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        //   slidesToSlide: 1 // optional, default to 1.
        }
      };
  return (
    <>
         <Card className='no-border rounded-0 architectural-modeling container'>
            <Card className='text-center no-border rounded-0'>
                <Card.Body>
                    <Card.Title className='architectural-modeling-title'>Photogrammetry Authenticity and Optimization</Card.Title>
                    <Card.Text className='architectural-modeling-text'>
                    In addition to manual modeling of digital twins from reference images and conversion of engineering CAD files, we are expert in Photogrammetry, in which hundreds or thou sands of photos of real objects and places are converted into 3D digital twins. While photogrammetry is notorious for issues ranging from “melted” models with holes and gaps to massively “heavy” models with millions of polygons unsuitable for AR and VR, w e have developed techniques to blend highly detailed and accurate photographic textures with highly optimized and simplified 3D models. 
                    <br />
                    <br /> Our team can take photos of real places around the world and build 3D virtual graphics that are exceptionally close to the real ones yet highly performant . For example, we have recreated parts of the vast Pashupatinath temple as a digital twin that can be visited in VR . Located in Kathmandu, Nepal, the temple is the third most holy Hindu temple and a place of pilgrimage. In addition to the photogrammetry - based 3D models, we added other interactive elements, such as burning incense and real 360 photospheres and 360 videos you can hold to your (virtual) head to view the temple in real - life and take narrative tours.
                    </Card.Text>

                    {/* <Card.Text> */}
                    <div className="pashupatinath-carousel-body">
                    <Carousel
                     responsive={responsive}
                     autoPlay={false}
                     arrows={isMobile ? false : true }
                     centerMode={ isMobile ? false : true }
                     slidesToSlide={1}
                     infinite={true}
                     showDots={true}
                    //  keyBoardControl={true}
                     renderDotsOutside={true}
                     draggable={false}
                     autoPlaySpeed={3000}
                    >
                        <div>
                            <img className="d-block w-100 px-md-2" src={process.env.PUBLIC_URL + "assets/digital-twin/photogrammetry/images/ph_001.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={process.env.PUBLIC_URL + "assets/digital-twin/photogrammetry/images/ph_002.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={process.env.PUBLIC_URL + "assets/digital-twin/photogrammetry/images/ph_003.jpg"} alt="" />
                        </div>
                    </Carousel>
                    </div>
                    {/* </Card.Text> */}
                </Card.Body>
            </Card>
            <Card className='no-border rounded-0'>
                <Row>
                    <Col md={{span:8, offset:2}} className="my-md-3 py-md-4">
                        <VideoPlayer videosource="assets/digital-twin/photogrammetry/video/pashupatinath-photogrammetry.mp4" class="winery-video container" />
                    </Col>

                    <Col md={{span:8, offset:2}} className="my-md-3 py-md-4">
                        <Card.Subtitle className='pashupatinath-subtitle'>Pashupatinath fly through video</Card.Subtitle>
                        <VideoPlayer videosource="assets/digital-twin/photogrammetry/video/pashupatinath-flythrough.mp4" class="winery-video container  " />
                    </Col>

                </Row>
            </Card>
        </Card>
      
    </>
  )
}

export default Photogrammetry
